import React from "react";
import SocialLink from "./SocialLink";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { FaLinkedinIn } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";

export default function SocialMediaIcons({ socialMediaIcons }) {
  const getSocialLinks = (name) => socialMediaIcons && socialMediaIcons.length > 0 && socialMediaIcons?.find(social => social.name === name)?.link || '';
  return (
    <div className="flex gap-3 sm:order-1">
      <SocialLink link={getSocialLinks("Facebook")} icon={FaFacebookF} labelName="Facebook" />
      <SocialLink link={getSocialLinks("Twitter")} icon={FaTwitter} labelName="Twitter" />
      <SocialLink link={getSocialLinks("Instagram")} icon={RiInstagramFill} labelName="Instagram" />
      <SocialLink link={getSocialLinks("Linkedin")} icon={FaLinkedinIn} labelName="Linkedin" />
      <SocialLink link={getSocialLinks("Youtube")} icon={FaYoutube} labelName="Youtube" />
    </div>
  );
}
